import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class CompressorDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new CompressorDeviceBox({
            uuid,
            graph,
            name: "CompressorDeviceBox",
            pointerRules: {
                accepts: [Pointers.Device, Pointers.Selection],
                mandatory: false,
            },
        }), constructor);
    }
    static ClassName = "CompressorDeviceBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitCompressorDeviceBox, this);
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get lookahead() {
        return this.getField(10);
    }
    get automakeup() {
        return this.getField(11);
    }
    get autoattack() {
        return this.getField(12);
    }
    get autorelease() {
        return this.getField(13);
    }
    get inputgain() {
        return this.getField(14);
    }
    get threshold() {
        return this.getField(15);
    }
    get ratio() {
        return this.getField(16);
    }
    get knee() {
        return this.getField(17);
    }
    get attack() {
        return this.getField(18);
    }
    get release() {
        return this.getField(19);
    }
    get makeup() {
        return this.getField(20);
    }
    get mix() {
        return this.getField(21);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                pointerRules: NoPointers,
            }, Pointers.AudioEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                pointerRules: NoPointers,
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                pointerRules: NoPointers,
            }, false),
            10: BooleanField.create({
                parent: this,
                fieldKey: 10,
                fieldName: "lookahead",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, false),
            11: BooleanField.create({
                parent: this,
                fieldKey: 11,
                fieldName: "automakeup",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, true),
            12: BooleanField.create({
                parent: this,
                fieldKey: 12,
                fieldName: "autoattack",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, false),
            13: BooleanField.create({
                parent: this,
                fieldKey: 13,
                fieldName: "autorelease",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, false),
            14: Float32Field.create({
                parent: this,
                fieldKey: 14,
                fieldName: "inputgain",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 0),
            15: Float32Field.create({
                parent: this,
                fieldKey: 15,
                fieldName: "threshold",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, -10),
            16: Float32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "ratio",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 2),
            17: Float32Field.create({
                parent: this,
                fieldKey: 17,
                fieldName: "knee",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 0),
            18: Float32Field.create({
                parent: this,
                fieldKey: 18,
                fieldName: "attack",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 0),
            19: Float32Field.create({
                parent: this,
                fieldKey: 19,
                fieldName: "release",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 5),
            20: Float32Field.create({
                parent: this,
                fieldKey: 20,
                fieldName: "makeup",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 0),
            21: Float32Field.create({
                parent: this,
                fieldKey: 21,
                fieldName: "mix",
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MidiControl,
                    ],
                    mandatory: false,
                },
            }, 1),
        };
    }
}
